import { render, staticRenderFns } from "./ManagementClaimSettings.vue?vue&type=template&id=f935692c"
import script from "./ManagementClaimSettings.vue?vue&type=script&lang=js"
export * from "./ManagementClaimSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports